<template>
  <v-container>
    <v-row justify="center">
      <v-col
        cols=4
        sm=2>
        <v-checkbox
          v-model="handlingCode1"
          label="H1"
          ></v-checkbox>
      </v-col>
      <v-col
        cols=4
        sm=2>
        <v-checkbox
          v-model="handlingCode2"
          label="H2"
          ></v-checkbox>
      </v-col>
      <v-col
        cols=4
        sm=2
        >
        <v-checkbox
          v-model="handlingCode3"
          label="H3"
          ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p><span class="font-weight-bold">H1:</span> {{ $t('handling_code_1') }}</p>
        <p><span class="font-weight-bold">H2:</span> {{ $t('handling_code_2') }}</p>
        <p><span class="font-weight-bold">H3:</span> {{ $t('handling_code_3') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'HandlingCodes',
  data: vm => ({
    handlingCode1: true,
    handlingCode2: true,
    handlingCode3: false
  }),
  methods: {
    getData: function () {
      return {
        h1: this.handlingCode1,
        h2: this.handlingCode2,
        h3: this.handlingCode3
      }
    },
    setData: function (data) {
      this.handlingCode1 = data.h1
      this.handlingCode2 = data.h2
      this.handlingCode3 = data.h3
    }
  }
}
</script>
